import type { ReactNode } from "react";

import { cn } from "@/lib/utils";

export interface ResponsiveListSplitProps {
  /** Table layout — visible from `lg` breakpoint up. */
  table: ReactNode;
  /** Card / stacked list — visible below `lg`. */
  cards: ReactNode;
  className?: string;
}

/**
 * Renders a data table on large+ viewports and a stacked card list on small
 * and medium screens. The `lg` breakpoint (1024px) matches the Header/Sidebar
 * so the hamburger menu and card layout appear together on tablets.
 */
export function ResponsiveListSplit({
  table,
  cards,
  className,
}: ResponsiveListSplitProps): JSX.Element {
  return (
    <div className={cn(className)}>
      <div className="hidden lg:block">{table}</div>
      <div className="lg:hidden">{cards}</div>
    </div>
  );
}
